import { useContext } from 'react'

import { AppContext } from '../../stores/App/AppStore'
import { ActionTypes } from '../../stores/App/AppReducer'
import BundleRepository from './bundle-repository'
import { Membership, MembershipResponse } from '../../types/Membership'
import { UserActionTypes } from '../../stores/User/UserReducer'
import { starterDataError } from '../../helpers/utils/error-handling'
import { UserContext } from '../../stores/User/UserStore'

const useBundleRepository = () => {
    const { dispatch: appDispatch } = useContext(AppContext)
    const { dispatch: userDispatch } = useContext(UserContext)
    const bundleRepository = new BundleRepository()

    const retrieveBundle = (bundleCode?: string) => {
        if (bundleCode){
            bundleRepository.getBundle(bundleCode)
                .then((bundlePage) => {
                    appDispatch({
                        type: ActionTypes.BUNDLE_LANDING_PAGE_RETRIEVED,
                        content: bundlePage,
                    })
                })
                .catch((error) => {
                    console.error(error.message)
                })
        }
    }

    const updateMembershipFromNonPaymentBundle = async (bundleCode: string) => {
        const membershipResponse: MembershipResponse = {}
        return bundleRepository.updateMembershipFromNonPaymentBundle(bundleCode)
            .then((membership: Membership) => {
                membershipResponse.data = membership
            })
            .catch(error => {
                membershipResponse.error = starterDataError(error)
                return membershipResponse
            })
            .finally(() => {
                userDispatch({
                    type: UserActionTypes.MEMBERSHIP_DATA_RETRIEVED,
                    data: membershipResponse,
                })
            })
    }

    const createBundlePaymentOrder = (bundleCode: string) => {
        return bundleRepository.createBundlePaymentOrder(bundleCode)
    }

    const updateMembershipAfterPaymentForBundle = (bundleCode: string, stripePaymentIntentId: string) => {
        const membershipResponse: MembershipResponse = {}
        return bundleRepository.updateMembershipAfterPaymentForBundle(bundleCode, stripePaymentIntentId)
            .then((membership: Membership) => {
                membershipResponse.data = membership
            })
            .catch(error => {
                membershipResponse.error = starterDataError(error)
                return membershipResponse
            })
            .finally(() => {
                userDispatch({
                    type: UserActionTypes.MEMBERSHIP_DATA_RETRIEVED,
                    data: membershipResponse,
                })
            })
    }

    const saveBundleCode = (bundleCode?: string) => {
        bundleRepository.setBundleCode(bundleCode)
    }

    const resetBundleCode = () => {
        bundleRepository.setBundleCode()
    }

    const retrieveBundleCode = () => {
        return bundleRepository.getBundleCode() ?? undefined
    }

    return {
        retrieveBundle,
        saveBundleCode,
        retrieveBundleCode,
        resetBundleCode,
        updateMembershipFromNonPaymentBundle,
        createBundlePaymentOrder,
        updateMembershipAfterPaymentForBundle,
    }
}

export { useBundleRepository }